import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'serviço de quarto',
      [RoomServiceLocationType.TableService]: 'serviço de mesa',
    },
    [ORDER_METHODS.PICKUP]: 'takeaway',
    [ORDER_METHODS.DELIVERY]: 'entrega',
  },
  errors: {
    draft_validation_failed: 'Por favor, complete a sua morada de entrega antes de continuar.',
  },
};
